import styled from "styled-components";

export const AutocompleteContainer = styled.div`
  top: 100%;
  flex-direction: column;

  ${({ isFocused, isAnchored }) => `
    display:  ${isFocused ? "flex" : "none"};

    @media only screen and (max-width: 767px) {
      top: ${isAnchored ? `calc(2rem + 100%)` : "100%"};
    }
  `}

  position: absolute;
  left: 0;
  right: 0;
  z-index: 7;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 0 0 7px 7px;
  background-color: white;
`;

export const AutocompleteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
`;

export const AutocompleteHeaderText = styled.p`
  font-size: 1.5em;
  font-weight: 700;
`;

export const SuggestionSearchIcon = styled.button`
  -webkit-appearance: button;
  border: none;
  height: 15px;
  width: 15px;
  margin-right: 10px;

  background: transparent;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg fill='currentColor' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50' width='50px' height='50px'%3e%3cpath d='M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z'/%3e%3c/svg%3e");
  background-size: contain;
  background-repeat: no-repeat;

  cursor: pointer;
`;

export const SuggestionContainer = styled.ul`
  padding: 0;
  margin: 0;
  width: 100%;
  max-height: 300px;

  overflow: auto;
  overflow-x: hidden;

  scrollbar-width: thin;

  border-top: 1px solid rgb(230, 230, 230);

  :first-child {
    border: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
  }

  @media only screen and (min-width: 650px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    max-height: 400px;
  }
`;

export const SuggestionDefaultItem = styled.li`
  display: flex;
  align-items: center;
  height: 2.5rem;
  list-style-type: none;
  cursor: pointer;
  padding: 0rem 0.5rem;
  font-size: 13px;
  margin: 10px 0px;

  :hover {
    background-color: rgb(245, 245, 245);
  }

  @media only screen and (max-width: 767px) {
    font-size: 12px;
    padding: 0 0.25rem;
  }

  @media only screen and (max-width: 480px) {
    font-size: 11px;
    margni: 7px 0;
  }
`;

export const SuggestionListItem = styled.li`
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  cursor: pointer;

  :hover {
    background-color: rgb(245, 245, 245);
  }
`;

export const ListItemImage = styled.img`
  height: 64px;

  @media only screen and (min-width: 650px) {
    height: 80px;
  }
`;

export const ListItemTitle = styled.span`
  flex-grow: 1;
  padding: 0 20px;
  font-size: 14px;
`;

export const ListItemPrice = styled.span`
  font-size: 14px;
  white-space: nowrap;
`;

export const GridLayout = styled.div`
  display: grid;
  grid-template:
    "list"
    "products";

  @media (min-width: 650px) {
    grid-template: "list . products";
    grid-template-columns: 1fr 10px 2.8fr;
  }

  &:not(:has(.bn-search__autocomplete-products)) {
    grid-template: "list";
  }

  &:not(:has(.bn-search__autocomplete-grid-list)) {
    grid-template: "products";
  }
`;

export const GridListItems = styled.div`
  grid-area: list;
`;

export const GridSuggestionContainer = styled.ul`
  grid-area: products;
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  gap: 16px;

  overflow: auto;
  overflow-x: hidden;

  padding: 10px 0;
  margin: 0;
  max-height: 70vh;

  width: 100%;

  scrollbar-width: thin;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
  }

  @media only screen and (min-width: 650px) {
    grid-template-columns: repeat(5, minmax(150px, 1fr));
  }
`;

export const SuggestionGridItem = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px 10px;
  cursor: pointer;
`;

export const GridItemImageContainer = styled.div`
  position: relative;
`;

export const GridItemImage = styled.img`
  align-self: center;
  height: auto;
  width: auto;
  max-width: 100%;
`;

export const GridItemTitle = styled.span`
  margin: 10px 0;
`;

export const GridItemPrice = styled.span`
  display: flex;
  flex-direction: column;

  .bn-search__suggestion-price-from,
  .bn-search__suggestion-price-avista,
  .bn-search__suggestion-installments {
    display: none;
  }

  .bn-search__suggestion-price-from {
    font-size: 12px;
    text-decoration: line-through;
    line-height: 1;
    font-weight: 400;
  }

  .bn-search__suggestion-price-avista {
    &::after {
      content: "à vista";
      margin-left: 3px;
    }
  }

  .bn-search__suggestion-installments {
    flex-wrap: wrap;
    font-size: 16px;
    font-weight: 400;
    margin-top: 5px;

    .bn-search__suggestion-installments-price-to {
      display: none;
    }

    .bn-search__suggestion-installments-months {
      &::before {
        content: "em até";
        margin-right: 3px;
      }
    }

    .bn-search__suggestion-installments-amount {
      &::before {
        content: "de";
        margin: 0 3px;
      }

      &::after {
        content: "sem juros";
        margin-left: 3px;
      }
    }
  }
`;
